import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
    flex-shrink: 0;
    justify-self: start;
    width: fit-content;
    max-width: 100%;
    min-width: 0;

    & > div {
        max-width: 100%;
        min-width: 0;
    }
`;
